import React from "react";

export function SvgArrowsIcon() {
  return<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="m21.936 15.545-2.88-2.88a.48.48 0 1 0-.682.681l2.064 2.055H2.4a.48.48 0 0 0 0 .96h18.038l-2.064 2.064a.485.485 0 0 0 0 .681.481.481 0 0 0 .682 0l2.88-2.88a.48.48 0 0 0 0-.681zM2.062 8.725l2.88 2.88a.48.48 0 1 0 .682-.682L3.56 8.87h18.038a.48.48 0 1 0 0-.96H3.56l2.064-2.064a.482.482 0 0 0-.682-.682l-2.88 2.88a.48.48 0 0 0 0 .682z" fill="#7FCD22"/>
</svg>;
}